(function () {
  var orders = window.CP_recentOrders || [];
  if (!orders.length) return;

  // Exclude on cart and checkout pages
  var path = window.location.pathname;
  if (path.indexOf('/cart') === 0 || path.indexOf('/checkouts') === 0 || path.indexOf('/checkout') === 0) return;

  // ---- Storage keys ----
  var SK_SESSION_COUNT    = 'cp_notify_session_count';    // sessionStorage: flyouts shown this session
  var SK_SESSION_URLS     = 'cp_notify_session_urls';     // sessionStorage: URLs that already fired
  var SK_SEEN_ORDERS      = 'cp_notify_seen_orders';      // localStorage:   order ts values shown ever
  var SK_WINDOW_START     = 'cp_notify_window_start';     // localStorage:   timestamp of first flyout in current 12h window
  var SK_WINDOW_COUNT     = 'cp_notify_window_count';     // localStorage:   flyouts shown in current 12h window

  var MAX_PER_SESSION     = 2;
  var MAX_PER_WINDOW      = 2;
  var WINDOW_MS           = 12 * 60 * 60 * 1000;  // 12 hours
  var DELAY               = 8;   // seconds before first notification
  var DURATION            = 9;   // seconds on screen
  var MAX_AGE_DAYS        = 60;  // hide orders older than this

  // ---- Rule 4: Check/reset 12-hour window ----
  var now = Date.now();
  var windowStart = parseInt(localStorage.getItem(SK_WINDOW_START) || '0', 10);
  var windowCount = parseInt(localStorage.getItem(SK_WINDOW_COUNT) || '0', 10);

  if (windowStart > 0 && (now - windowStart) >= WINDOW_MS) {
    // 12 hours have passed — reset
    localStorage.removeItem(SK_WINDOW_START);
    localStorage.removeItem(SK_WINDOW_COUNT);
    windowStart = 0;
    windowCount = 0;
  }

  // If within 12h window and already at max, block entirely
  if (windowStart > 0 && windowCount >= MAX_PER_WINDOW) return;

  // ---- Rule 1: Check session count ----
  var sessionCount = parseInt(sessionStorage.getItem(SK_SESSION_COUNT) || '0', 10);
  if (sessionCount >= MAX_PER_SESSION) return;

  // ---- Rule 2: Check if this URL already fired this session ----
  var currentUrl = window.location.pathname + window.location.search;
  var sessionUrls = [];
  try { sessionUrls = JSON.parse(sessionStorage.getItem(SK_SESSION_URLS) || '[]'); } catch(e) {}
  if (sessionUrls.indexOf(currentUrl) !== -1) return;

  // ---- Rule 3: Get list of already-seen order timestamps ----
  var seenOrders = [];
  try { seenOrders = JSON.parse(localStorage.getItem(SK_SEEN_ORDERS) || '[]'); } catch(e) {}

  // ---- Filter orders ----
  var cutoff = now - (MAX_AGE_DAYS * 24 * 60 * 60 * 1000);
  var eligible = orders.filter(function (o) {
    if (o.ts <= cutoff) return false;                          // too old
    if (seenOrders.indexOf(o.ts) !== -1) return false;        // Rule 3: already seen
    return true;
  });

  if (!eligible.length) return;

  // ---- DOM refs ----
  var box      = document.getElementById('cp-notify-box');
  var imgEl    = document.getElementById('cp-notify-img');
  var nameEl   = document.getElementById('cp-notify-name');
  var locEl    = document.getElementById('cp-notify-loc');
  var fromEl   = document.getElementById('cp-notify-from');
  var prodEl   = document.getElementById('cp-notify-prod');
  var timeEl   = document.getElementById('cp-notify-time');
  var closeEl  = document.getElementById('cp-notify-close');
  var imgLink  = document.getElementById('cp-notify-img-link');
  var prodLink = document.getElementById('cp-notify-prod-link');

  if (!box) return;

  function timeAgo(ts) {
    var diff = Math.floor((now - ts) / 1000);
    if (diff < 60)    { return diff + ' second' + (diff === 1 ? '' : 's') + ' ago'; }
    if (diff < 3600)  { var m = Math.floor(diff / 60);   return m + ' minute' + (m === 1 ? '' : 's') + ' ago'; }
    if (diff < 86400) { var h = Math.floor(diff / 3600); return h + ' hour'   + (h === 1 ? '' : 's') + ' ago'; }
    var d = Math.floor(diff / 86400);
    return d + ' day' + (d === 1 ? '' : 's') + ' ago';
  }

  function recordShown(order) {
    // Rule 1: increment session count
    sessionCount++;
    sessionStorage.setItem(SK_SESSION_COUNT, sessionCount);

    // Rule 2: record this URL
    sessionUrls.push(currentUrl);
    sessionStorage.setItem(SK_SESSION_URLS, JSON.stringify(sessionUrls));

    // Rule 3: record this order as seen
    seenOrders.push(order.ts);
    if (seenOrders.length > 50) seenOrders = seenOrders.slice(-50); // cap list size
    localStorage.setItem(SK_SEEN_ORDERS, JSON.stringify(seenOrders));

    // Rule 4: update 12h window
    if (windowStart === 0) {
      // Start the window now
      windowStart = now;
      localStorage.setItem(SK_WINDOW_START, windowStart);
      windowCount = 0;
    }
    windowCount++;
    localStorage.setItem(SK_WINDOW_COUNT, windowCount);
  }

  function hide() {
    box.classList.remove('cp-notify--visible');
    box.classList.add('cp-notify--hidden');
  }

  function show(order) {
    nameEl.textContent = order.name || 'Someone';
    locEl.textContent  = order.loc  || '';
    prodEl.textContent = order.prod || '';
    timeEl.textContent = timeAgo(order.ts);

    if (fromEl) fromEl.style.display = order.loc ? '' : 'none';
    if (imgLink)  imgLink.href  = order.url || '#';
    if (prodLink) prodLink.href = order.url || '#';

    if (order.img) {
      imgEl.src           = order.img;
      imgEl.style.display = 'block';
    } else {
      imgEl.style.display = 'none';
    }

    recordShown(order);

    box.classList.remove('cp-notify--hidden');
    box.classList.add('cp-notify--visible');
    setTimeout(hide, DURATION * 1000);
  }

  if (closeEl) {
    closeEl.addEventListener('click', function () {
      hide();
      // Count a close as consuming the session slot for this URL
      // (already recorded via recordShown before show() returns)
    });
  }

  setTimeout(function () {
    show(eligible[0]);
  }, DELAY * 1000);

})();
